angular.module("vgresiduos").directive("supplierFilter", function () {
	return {
		scope: false,
		templateUrl: "views/suppliers/grid/general/supplierFilter_template.html"
	};
});
